module.exports = __webpack_public_path__ + "static/36-3c93f974fda9aa0757206e91e9d6f440.png";